import * as types from "./commonActionTypes";
import Cookies from "js-cookie";
import fetchUrl from "../services/fetchUrl";
import {
  showSnackBar,
  showSuccessSnackBar
} from "../components/Snackbar/snackbarActions";
import makeAjaxRequest from "../services/makeAjaxRequest";

import {
  FEEDBACK,
  TO_MANY_ATTEMPT,
  PRODUCTION_URL
} from "../services/constants";
import { detectMobile, getErrorMessage } from "../services/utils";
import {
  PUBLIC_DOWNLOAD_ALERT,
  PUBLIC_OTP_ALERT
} from "../services/webengage/webEngageConstants";
import { getLocalStorage } from "../utils/localStorage";
import ClmGetTrackingService from "../services/ClmTrackingService";
import ProfileService from "../services/ProfileService";
import { fireFacebookPixelEvent } from "services/FacebookPixelService";
import useUserProfileStore from "../zustandStores/userProfileStore";
import useJobOwnershipStore from "../zustandStores/useJobOwnershipStore";
import { useJobPostingSessionStore } from "../zustandStores/jobPostingSessionStore";
import { JPF_SESSION_INFO_KEY } from "../services/constants";

export const getJobList = () => {
  return dispatch => {
    dispatch(getJobListLoading());
    makeAjaxRequest({
      method: "GET",
      url: fetchUrl("recruiter", "job/list"),
      auth: true
    })
      .then(response => {
        dispatch(getJobListSuccess(response.data.data));
      })
      .catch(error => {
        dispatch(getJobListFailure(error.message));
        dispatch(showSnackBar(error.message));
      });
  };
};

export const getJobListLoading = () => {
  return {
    type: types.GET_JOB_LIST_LOADING
  };
};

export const getJobListSuccess = payload => {
  return {
    type: types.GET_JOB_LIST_SUCCESS,
    payload: payload
  };
};

export const getJobListFailure = error => {
  return {
    type: types.GET_JOB_LIST_FAILURE,
    payload: error
  };
};

export const getQueryParam = queryParam => {
  Cookies.set("phone", queryParam.phone);
  return {
    type: types.GET_QUERY_PARAM,
    queryParam: queryParam
  };
};

export const logEvents = (nameObject, info, status) => {
  try {
    const rec_access_token = !!Cookies.get("rec_access_token");
    let sessionId = "";
    if (process.browser) {
      sessionId = getLocalStorage("recSessionId");
    }
    const profileData = useUserProfileStore.getState().profileData;
    let isJobOwned = undefined;
    if (info?.job_id || info?.jobId) {
      const jobId = info?.job_id || info?.jobId;
      isJobOwned = useJobOwnershipStore.getState().isJobOwned(jobId);
    }

    let eventInfo = {
      ...info,
      session_id: sessionId,
      rec_session_id: sessionId,
      pageUrlSource: window.location.href,
      userType: profileData?.userType || undefined,
      userCohort: profileData?.userCohort || undefined,
      isJobOwned
    };

    // ADD V2 SESSION TRACKING LOGIC HERE
    if (nameObject[JPF_SESSION_INFO_KEY]) {
      try {
        const sessionStore = useJobPostingSessionStore.getState();

        // Get session data from store
        const sessionData = {
          jpf_session_id: sessionStore.getSessionId()
        };

        // MERGE session data with existing eventInfo
        // Session data has lower priority - existing eventInfo takes precedence
        eventInfo = {
          ...sessionData,  // Session data first (lower priority)
          ...eventInfo     // Existing eventInfo second (higher priority)
        };
      } catch (error) {
        // Silently continue if session store unavailable
      }
    }
    // END OF ADDED LINES

    if (process.browser && window?.location?.search) {
      const params = new URLSearchParams(window.location.search);
      if (params && params.get) {
        const m = params.get("m");
        if (m == 1) {
          eventInfo.appPurchase = true;
        }
      }
    }
    return dispatch => {
      ClmGetTrackingService().track({
        eventName: nameObject.name,
        value: info
      });

      if (process.env.BASE_URL === "https://api.jobhai.com") {
        if (window.gtag) {
          window.gtag("event", nameObject.name, {
            device_id: Cookies.get("recDeviceId"),
            send_to: ["G-95RRWMBJ2G"]
          });
        }
        // Simplified Facebook Pixel tracking with only recruiter_id and recruiter_phone
        fireFacebookPixelEvent(nameObject.name);
      }

      dispatch(logEventsLoading());

      const env =
        process.env.LIVE_URL !== PRODUCTION_URL ? "staging" : "production";
      const isNativeApp = Cookies.get("is_native_app");

      makeAjaxRequest({
        method: rec_access_token ? "POST" : "POST_NO_AUTH",
        url: fetchUrl("logs", "log-events"),
        data: [
          {
            event_category: nameObject.category,
            event_type: nameObject.name,
            event_info: JSON.stringify(eventInfo),
            source: isNativeApp
              ? `app-web-view-${env}`
              : detectMobile()
                ? `mobile-website-${env}`
                : `desktop-website-${env}`,
            user_type: "recruiter",
            event_status: status ? "true" : true,
            updatedAt: new Date(),
            createdAt: new Date()
          }
        ]
      })
        .then(response => {
          dispatch(logEventsSuccess(response.data.data));
        })
        .catch(error => {
          dispatch(logEventsFailure(error.message));
          console.log("Error in Event log!!");
        });
    };
  } catch (error) { }
};

export const logEventsLoading = () => {
  return {
    type: types.LOG_EVENTS_LOADING
  };
};

export const logEventsSuccess = payload => {
  return {
    type: types.LOG_EVENTS_SUCCESS,
    payload: payload
  };
};

export const logEventsFailure = error => {
  return {
    type: types.LOG_EVENTS_FAILURE,
    payload: error
  };
};

// NPS Feedback API
export const getNpsQuestions = () => {
  return dispatch => {
    dispatch(getNpsQuestionsLoading());
    makeAjaxRequest({
      method: "GET",
      url: fetchUrl("v2/metadata", "nps_questions"),
      auth: false
    })
      .then(response => {
        dispatch(getNpsQuestionsSuccess(response.data.data));
      })
      .catch(error => {
        dispatch(getNpsQuestionsFailure(error.message));
        dispatch(showSnackBar(error.message));
      });
  };
};

export const getNpsQuestionsLoading = () => {
  return {
    type: types.NPS_QUESTIONS_LOADING
  };
};

export const getNpsQuestionsSuccess = payload => {
  return {
    type: types.NPS_QUESTIONS_SUCCESS,
    payload: payload
  };
};

export const getNpsQuestionsFailure = error => {
  return {
    type: types.NPS_QUESTIONS_FAILURE,
    payload: error
  };
};

export const submitNpsFeedback = (number, options = [], textAnswer = "") => {
  return dispatch => {
    dispatch(submitNpsFeedbackLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "save-nps"),
      data: { score: number, options, text_answer: textAnswer }
    })
      .then(response => {
        // dispatch(submitNpsFeedbackSuccess(response.data.data));
        if (options.length > 0) dispatch(showSuccessSnackBar(FEEDBACK));
      })
      .catch(error => {
        dispatch(submitNpsFeedbackFailure(error.message));
      });
  };
};

export const submitNpsFeedbackLoading = () => {
  return {
    type: types.NPS_SUBMIT_LOADING
  };
};

export const submitNpsFeedbackSuccess = payload => {
  return {
    type: types.NPS_SUBMIT_SUCCESS,
    payload: payload
  };
};

export const submitNpsFeedbackFailure = error => {
  return {
    type: types.NPS_SUBMIT_FAILURE,
    payload: error
  };
};

export const closeNpsFeedback = () => {
  return dispatch => {
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "decline-nps-nudge")
    })
      .then(response => { })
      .catch(error => {
        dispatch(closeNpsFeedbackFailure(error.message));
      });
  };
};

export const closeNpsFeedbackFailure = error => {
  return {
    type: types.NPS_SUBMIT_FAILURE,
    payload: error
  };
};

// END NPS Feedback API

export const getDeviceType = type => {
  return dispatch => {
    dispatch({
      type: types.GET_DEVICE_TYPE,
      deviceType: type
    });
  };
};

/**** Start API for Referal *******/

export const getReferral = (page = "CLOSE_JOB") => {
  return dispatch => {
    dispatch(getReferralLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "referral"),
      data: {
        page: page
      },
      auth: true
    })
      .then(response => {
        let data = response.data.data;
        dispatch(getReferralSuccess(data));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(getReferralFailure(error));
      });
  };
};

export const getReferralLoading = () => {
  return {
    type: types.REFERRAL_LOADING
  };
};

export const getReferralSuccess = payload => {
  return {
    type: types.REFERRAL_SUCCESS,
    payload: payload
  };
};

export const getReferralFailure = error => {
  return {
    type: types.REFERRAL_FAILURE,
    payload: error
  };
};

/***** End API for Referal *****/

/* Show SMS Alert Message */
export const smsWarningAlert = (phone, type = "download") => {
  const countOTP =
    type === "OTP"
      ? Cookies.get("rec_otp_count")
      : Cookies.get("rec_sms_count");
  const attemptCount = countOTP ? Number(countOTP) + 1 : 1;
  return dispatch => {
    dispatch(
      logEvents(type === "OTP" ? PUBLIC_OTP_ALERT : PUBLIC_DOWNLOAD_ALERT, {
        phone,
        attempt_count: attemptCount
      })
    );
    dispatch(showSnackBar(TO_MANY_ATTEMPT));
  };
};

/**** Start API for Managing Recruiter session  *******/

export const manageSession = type => {
  return dispatch => {
    dispatch(manageSessionLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "manage-session"),
      data: { type }
    })
      .then(response => {
        const { data } = response.data;
        dispatch(manageSessionSuccess(data));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(manageSessionFailure(error));
      });
  };
};

export const manageSessionLoading = () => {
  return {
    type: types.MANAGE_SESSION_LOADING
  };
};

export const manageSessionSuccess = payload => {
  return {
    type: types.MANAGE_SESSION_SUCCESS,
    payload
  };
};

export const manageSessionFailure = error => {
  return {
    type: types.MANAGE_SESSION_FAILURE,
    payload: error
  };
};

export const setIsTooltipShowing = payload => {
  return {
    type: types.IS_TOOLTIP_SHOWING,
    payload: payload
  };
};

export const setAppLoader = payload => {
  return {
    type: types.IS_APP_LOADING,
    payload
  };
};

/***** End API for Managing Recruiter session *****/

/**** Start API for Job Refresh  *******/

export const jobRefresh = (jobId, callBack) => {
  return dispatch => {
    dispatch(jobRefreshLoading());
    dispatch(setAppLoader(true));
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("recruiter", "job/refresh-job"),
      data: { jobId }
    })
      .then(response => {
        const { data } = response.data;
        dispatch(jobRefreshSuccess(data));
        return response;
      })
      .then(response => {
        dispatch(setAppLoader(false));

        if (callBack) {
          const { newlyAddedCandidatesCount } = response?.data?.data || {};
          if (
            newlyAddedCandidatesCount !== undefined &&
            newlyAddedCandidatesCount !== null
          ) {
            callBack({ newlyAddedCandidatesCount, jobId });
          }
        }
      })
      .catch(error => {
        dispatch(setAppLoader(false));

        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(jobRefreshFailure(error));
      });
  };
};

export const jobRefreshLoading = () => {
  return {
    type: types.JOB_REFRESH_LOADING
  };
};

export const jobRefreshSuccess = payload => {
  return {
    type: types.JOB_REFRESH_SUCCESS,
    payload
  };
};

export const jobRefreshFailure = error => {
  return {
    type: types.JOB_REFRESH_FAILURE,
    payload: error
  };
};

/***** End API for Job Refresh *****/

export const getPremiumIntentBannerLoading = () => {
  return {
    type: types.GET_PREMIUM_INTENT_LOADING
  };
};

export const getPremiumIntentBannerSuccess = payload => {
  return {
    type: types.GET_PREMIUM_INTENT_SUCCESS,
    payload
  };
};

export const getPremiumIntentBannerFailure = error => {
  return {
    type: types.GET_PREMIUM_INTENT_FAILURE,
    payload: error
  };
};

export const getPremiumIntentBanner = (params = {}) => {
  const { jobId, pageSource } = params;

  return dispatch => {
    dispatch(getPremiumIntentBannerLoading());
    ProfileService.getPremiumIntentBanner({
      job_id: jobId,
      page_source: pageSource
    })
      .then(response => {
        dispatch(getPremiumIntentBannerSuccess(response.data.data));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(getPremiumIntentBannerFailure());
      });
  };
};

export const handleCaptchaScreen = payload => {
  return dispatch => {
    dispatch({
      type: types.CAPTCHA_STATE,
      payload
    });
  };
};

export const setTooltipConditionsMet = payload => {
  return dispatch => {
    dispatch({
      type: types.SET_TOOLTIP_CONDITIONS_MET,
      payload: {
        ...payload
      }
    });
  };
};
